var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-container"},[_c('PageTabs',{key:_vm.$i18n.locale,attrs:{"pageLinks":_vm.contextLinks,"sectionName":_vm.$t('context.title')}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }